import React from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { keys as _keys, intersection as _intersection, size as _size } from 'lodash';

import { parseQs } from 'helpers/http';

class ListFilterReset extends React.Component {
  constructor(props) {
    super(props);

    const { location, availableFilters } = props;

    this.state = {
      show: this.checkShow(location, availableFilters),
    };
  }

  componentDidUpdate = prevProps => {
    const { location, availableFilters } = this.props;
    const { show } = this.state;

    if (location.search !== prevProps.location.search) {
      const shouldNowShow = this.checkShow(location, availableFilters);
      if (show !== shouldNowShow) {
        this.setState({ show: shouldNowShow });
      }
    }
  };

  checkShow = (location, availableFilters) => {
    const queryKeys = _keys(parseQs(location.search));
    return !!_size(_intersection(queryKeys, availableFilters));
  };

  reset = e => {
    e.preventDefault();

    const { location, history } = this.props;
    history.push(location.pathname);
  };

  render() {
    const {
      intl: { messages },
    } = this.props;
    const { show } = this.state;

    return show ? (
      <a href="#showFilterOptions" className="list-filter" onClick={this.reset}>
        {messages.reset}
      </a>
    ) : null;
  }
}
ListFilterReset.defaultProps = {
  availableFilters: [],
};

export default injectIntl(withRouter(ListFilterReset));
